import $ from "jquery";
window.$ = window.jQuery = $;

require('owl.carousel');

$(document).ready(function(){
	function isMobile(){
		let check = false;
		(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
		return check;
	}
	var mobile=isMobile();
	if(mobile){
		$('body').addClass('mobile');
	}
	let $header=$('#header');
	let $openLinks=$('#openLinks');
	$(document).scroll(function() {
		if($(window).scrollTop()>50){
			$header.addClass('scrolled');
		}
		else{
			$header.removeClass('scrolled');
		}
	});
	if($(window).scrollTop()>50){
		$header.addClass('scrolled');
	}
	$header.on('mouseleave',function(){
		if(!mobile){
			$header.find('.link-block ul').slideUp(250);
			$header.removeClass('links-opened');
		}
	});
	$('#openLinks h3').on('click',function(){
		$('.link-block ul').slideDown(250);
		$header.addClass('links-opened');
	});

	var slidr=$('#slider');
	var $slider=slidr.owlCarousel({
		dots: false,
		loop: false,
		items: 1,
		nav:true,
		autoplay: slidr.attr('data-autoplay'),
		autoplayTimeout: slidr.attr('data-timeout'),
		animateIn:'fadeIn',
		animateOut:'fadeOut',
		autoplayHoverPause:true,
		autoplay:true,
		autoplayTimeout:5000,
		navText:['<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 278.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>','<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M342.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L274.7 256 105.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>']
	});

	$slider.on('changed.owl.carousel', function(event) {
		$('#thumbnails .thumbnail[data-slide='+(event.item.index)+']').addClass('active').siblings().removeClass('active');
	});

	$('#thumbnails .thumbnail').on('click',function(){
		var $this=$(this);
		$slider.owlCarousel('to',[$this.attr('data-slide')]);
	});

	$('#videos .play-video').on('click',function(){
		var $this=$(this);
		$this.closest('.video-outer').addClass('video-playing').find('video').get(0).play();
		$this.closest('.video-outer').siblings().removeClass('video-playing').find('video').get(0).pause();
	});

	var $mobileHeader=$('#mobileHeader');
	$('#openMenu').on('click',function(){
		$mobileHeader.fadeIn();
	});
	$('#closeMenu').on('click',function(){
		$mobileHeader.fadeOut();
	});

	$('#linkTiles a').on('click',function(){
		let $this=$(this);
		$('#block-'+$this.attr('data-key')).fadeIn().siblings().hide();
	});

	$('#mobileHeader .back').on('click',function(){
		$('#nav-outer').fadeIn().siblings().hide();
	});

	var $contactForm=$('#contactForm');
	var $submitbtn=$('#submit');


	$('#toEmail').on('change',function(){
		let selectedCompany=$(this).find("option:selected").attr('data-company')
		$('#company').val(selectedCompany);
	});

	$('#products .open-blue-box').on('click',function(){
		var $this=$(this);
		$this.closest('#products').find('.blue-box').fadeOut(150);
		$this.closest('.product').find('.blue-box').fadeIn(150);
	});

	$('#products .close').on('click',function(){
		var $this=$(this);
		$this.closest('.product').find('.blue-box').fadeOut(150);
	});

	$contactForm.on('submit',function(e){
		var $this=$(this);
		e.preventDefault();
		$submitbtn.addClass('loading');
		if($('#hny').val()){
			$submitbtn.removeClass('loading');
			return;
		}
		$('#action').val('contact-form/send');
		$.post({
			url: '',
			dataType: 'json',
			data: $this.serialize(),
			success: function(response) {
				$submitbtn.removeClass('loading');
				if (response.success) {
					window.location.href = siteUrl+"thank-you-for-contacting-us";
				} else {
          // response.error will be an object containing any validation errors that occurred, indexed by field name
          // e.g. response.error.fromName => ['From Name is required']
          alert('An error occurred. Please try again.');
        }
      }
    });
	});
})